/**
 * Created by Alex Aguilar on 7/28/2016.
 */
(function(){
    'use strict';

    var sidebarMenu = {
        templateUrl: 'app/components/sidebarMenu/sidebarMenu.html',
        controller: sidebarMenuController,
        controllerAs: 'vm'
    };

    angular
        .module('completeAir')
        .component('sidebarMenu', sidebarMenu);

    sidebarMenuController.$inject = ['$timeout', 'sidebarMenuService']

    function sidebarMenuController($timeout, sidebarMenuService){
        var vm = this;
        vm.accessesMenu = [];

        vm.$postLink = function() {
            $timeout(function () {
                $("#sidebar-menu").metisMenu({
                    activeClass: 'active',
                    preventDefault: false,
                    onTransitionStart: function(){
                        $('.sub-title-final').on('click',  function(){
                            var element = $(this),
                                liParent = element.parent();

                            $('.sub-title-final').removeClass('title-active');
                            element.addClass('title-active');
                            $('.sub-title-active').removeClass('sub-title-active');
                            liParent.addClass('sub-title-active');
                        });
                    },
                    onTransitionEnd: function(){
                    }
                });
            }, 1000);
        }

        sidebarMenuService.getMenus()
            .then(function(response){
                vm.accessesMenu = response.data.menus;
                vm.$postLink();
            })
    }
})();


